import React from 'react'
import { Popup, Icon } from 'semantic-ui-react'
import { useCookies } from 'react-cookie'

import { useAppSelector } from 'redux/hooks'

import { getPriceStringFromFloat } from 'utils/Price'

import styles from './deckPrice.module.scss'

type Props = {
  costWithoutBasics: number
  estDeckCost: number
  excludingExactOwned: number
  excludingAnyOwned: number
}

const DeckPrice = ({ estDeckCost, costWithoutBasics, excludingExactOwned, excludingAnyOwned }: Props) => {
  const priceSource = useAppSelector(state => state.active.priceSource)
  const cardPackage = useAppSelector(state => state.deck.cardPackage)

  const excludingBasics = getPriceStringFromFloat(costWithoutBasics, priceSource[0])
  const excludingOwned = getPriceStringFromFloat(excludingExactOwned, priceSource[0])
  const excludingAny = getPriceStringFromFloat(excludingAnyOwned, priceSource[0])

  const resourceType = !cardPackage ? 'Deck' : 'Package'

  return (
    <Popup
      position="bottom left"
      content={
        <PopupBody excludingBasics={excludingBasics} excludingOwned={excludingOwned} excludingAny={excludingAny} />
      }
      trigger={
        <div style={{ whiteSpace: 'nowrap' }}>
          Est {resourceType.toLocaleLowerCase()} cost:{' '}
          <span className={styles.orange}>{getPriceStringFromFloat(estDeckCost, priceSource[0])}</span>
        </div>
      }
    />
  )
}

export default DeckPrice

type PopupProps = {
  excludingBasics: string
  excludingOwned: string
  excludingAny: string
}

const PopupBody = ({ excludingBasics, excludingAny, excludingOwned }: PopupProps) => {
  const [{ tbId: userId }] = useCookies(['tbId'])

  return (
    <div>
      <div>Excluding basic lands: {excludingBasics}</div>
      {!!userId && (
        <>
          <div>Excluding owned cards:</div>
          <div className={styles.ownedCards}>
            <div>Exact printings: {excludingOwned}</div>
            <div>Any printings: {excludingAny}</div>
          </div>
        </>
      )}
    </div>
  )
}
